import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { PromiseStatuses } from "../../../utils";
import {  GetAllM24OpenFiltersDTO, GetAllM24OpenResponseData } from "./dataService/dto";
import { MonitoringM24OpenService, NewMonitoringM24OpenService } from "./dataService/service";

interface MonitoringM24OpenState {
    // FILTERS
    GetAllM24OpenFilters: GetAllM24OpenFiltersDTO
    getAllM24OpenStatus: PromiseStatuses
    GetAllM24OpenResponse?: GetAllM24OpenResponseData[]

}

const initialState: MonitoringM24OpenState = {

    GetAllM24OpenFilters: {
        itemsPerPage: 500,
        page: 0
    },

    getAllM24OpenStatus: 'idle',
}

export const GetAllM24Open = createAsyncThunk(
    'monitoringM24Open/GetAllM24Open',
    async (filters: GetAllM24OpenFiltersDTO, thunkApi): Promise<GetAllM24OpenResponseData[]> => {
        const monitoringFaseAvvioService = NewMonitoringM24OpenService()

        return monitoringFaseAvvioService.GetAllM24Open(filters).catch(error => {
            throw (thunkApi.rejectWithValue(error))
        })
    },
)

const MonitoringM24OpenSlice = createSlice({
    name: 'MonitoringM24OpenSlice/slice',
    initialState,
    reducers: {
        // FILTERS
        setGetAllM24OpenFiltersItemsPerPage: (state, action) => {
            state.GetAllM24OpenFilters.itemsPerPage = action.payload
        },
        setGetAllM24OpenFiltersPage: (state, action) => {
            state.GetAllM24OpenFilters.page = action.payload
        },
        setGetAllM24OpenFiltersOrder: (state, action) => {
            state.GetAllM24OpenFilters.order = action.payload
        },
        setGetAllM24OpenFiltersSort: (state, action) => {
            state.GetAllM24OpenFilters.sort = action.payload
        },
        setGetAllM24OpenStartingDate: (state, action) => {
            state.GetAllM24OpenFilters.from = action.payload
        },
        setGetAllM24OpenType: (state, action) => {
            state.GetAllM24OpenFilters.type = action.payload
        },
        setGetAllM24OpenNorm: (state, action) => {
            state.GetAllM24OpenFilters.norm = action.payload
        },
        setGetAllM24OpenSot: (state, action) => {
            state.GetAllM24OpenFilters.sot = action.payload
        },
        setGetAllFaseAvvioEndingDate: (state, action) => {
            state.GetAllM24OpenFilters.to = action.payload
        },
        resetGetAllM24OpenFilters: (state) => {
            state.GetAllM24OpenFilters = {
                itemsPerPage: 500,
                page: 0
            }
        },
    },
    extraReducers(builder) {
        builder

            // GET ALL
            .addCase(GetAllM24Open.pending, (state) => {
                state.getAllM24OpenStatus = 'loading'
            })
            .addCase(GetAllM24Open.fulfilled, (state, action) => {
                state.getAllM24OpenStatus = 'successfully'
                state.GetAllM24OpenResponse = action.payload
            })
            .addCase(GetAllM24Open.rejected, (state) => {
                state.getAllM24OpenStatus = 'failed'
            })

    },
})

export const {
setGetAllFaseAvvioEndingDate,
setGetAllM24OpenStartingDate,
setGetAllM24OpenFiltersItemsPerPage,
setGetAllM24OpenNorm,
setGetAllM24OpenSot,
setGetAllM24OpenFiltersOrder,
setGetAllM24OpenFiltersPage,
setGetAllM24OpenFiltersSort,
setGetAllM24OpenType,
resetGetAllM24OpenFilters
} = MonitoringM24OpenSlice.actions

export default MonitoringM24OpenSlice.reducer